module.exports = __webpack_public_path__ + "img/DSC_2674-xs.7ef6fb31.png";